module.exports = __webpack_public_path__ + "static/media/b_icon_03.fc5a048b.png";